import { Product } from "@/contexts/InventoryContext";
import { API } from "@/lib/api";
import { ProductSalesRanksResponse, ProductSearchPage } from "@boxem/core-api-schema";

export interface Offer {
  IsBuyBoxWinner: boolean;
  IsFeaturedMerchant: boolean;
  IsFulfilledByAmazon: boolean;
  ListingPrice: {
    CurrentCode: string;
    Amount: number;
  };
  SellerFeedbackRating: {
    FeedbackCount: number;
    SellerPositiveFeedbackRating: number;
  };
  SellerId: string;
  Shipping: {
    CurrencyCode: string;
    Amount: number;
  };
  ShippingTime: {
    maximumHours: number;
    minimumHours: number;
    availabilityType: string;
  };
  ShipsFrom: {
    State: string;
    Country: string;
  };
  SubCondition: string;
  PrimeInformation?: {
    IsPrime: boolean;
    IsNationalPrime: boolean;
  };
}

export function getOffers(asin: string, condition: string = "New") {
  return API.post<Offer[]>("/products/offers", { asin, condition }, null);
};

export function getSalesRanksByASINs(asins: string[]) {
  return API.post<ProductSalesRanksResponse>("/products/sales-ranks", { asins }, null);
};

export async function getCatalogItems(query: string): Promise<[Product[], string]> {
  // @NOTE(nick) currently the b/e throws an error when searching with an empty string
  // (shuttled exception from amazon).
  // it may be better to have the b/e handle this more gracefully, but for now I am just not searching
  // with the empty string.
  if (query && query.length > 0) {
    const data = await API.get<ProductSearchPage>(
      `/products/search`,
      new URLSearchParams({
        search: query,
        itemsPerPage: "20", // we always request the max
      })
    );
    const products = data.products.map((catalogProduct) => {
      const product = new Product();
      product.asin = catalogProduct.asin;
      product.image = catalogProduct.image;
      product.name = catalogProduct.title;
      product.category = catalogProduct.category;
      product.categoryLink = catalogProduct.categoryLink;
      product.salesRank = catalogProduct.salesRank;
      product.hazmat = catalogProduct.hazmat;
      return product;
    });
    return [products, data.nextToken];
  }

  return [[], null];
}
